export enum Features {
    dashboard = 1,
    articles = 2,
    profile = 3,
    bonus_reports = 4,
    request_new_feature = 5,
    stocks = 6,
    etfs = 7,
    sectors = 8,
    main_search = 9,
    courses = 10,
    webinars = 11,
    alerts = 12,
    all_bpis = 13,
    equity_calculator = 14,
    etf_listing = 15,
    major_index_breadth = 17,
    options_calculator = 18,
    options_quotes = 19,
    position_key = 20,
    position_size_calculator = 21,
    rs_matrix = 22,
    rs_matrix_history = 23,
    sector_breadth = 24,
    spread_calculators = 25,
    scanner = 26,
    mentoring = 27,
    fullaccess = 28,
    trade_alerts = 29,
    notifications = 30,
    trade_of_the_day = 31,
    shadow_scanner = 32
}
